import { HttpResponse } from "@angular/common/http";

interface DownloadOptions {
    extension?: string;
    filename?: string;
  }

export default function getFilename(res: HttpResponse<Blob>, options?: DownloadOptions) {
    // Extract filename from header
    const disposition = res.headers.get('Content-Disposition');
    const matches = disposition?.split(';').map(v => v.trim());
    let filename = matches?.find(v => v.startsWith('filename='))?.substring(9)
      .replace(/"/g, '');

    // Handle optional extension override
    if (options && options.extension) {
      const ext = options.extension.startsWith('.') ? options.extension : `.${options.extension}`;
      filename = `${filename}${ext}`;
    }

    // Handle optional filename override
    return options && options.filename ? options.filename : filename;
  }
